import { AxiosRequestConfig, AxiosResponse } from 'axios';
import request from './config';
import { CITIZEN_API_URL } from './constants';

// Build the URL, ensuring no double slashes
const buildUrl = (endpoint: string): string => {
	const base = CITIZEN_API_URL.replace(/\/$/, '');
	const path = endpoint.replace(/^\//, '');
	return base ? `${base}/${path}` : `/${path}`;
};

export const get = (
	endpoint: string,
	cancelToken?: AxiosRequestConfig['cancelToken']
): Promise<AxiosResponse<any, any>> =>
	request.get(buildUrl(endpoint), {
		cancelToken
	});
// Binary GET for file downloads (exports, documents) — response body is a Blob.
export const getBlob = (endpoint: string): Promise<AxiosResponse<Blob>> =>
	request.get(buildUrl(endpoint), { responseType: 'blob' });
export const post = <req, res>(
	endpoint: string,
	data?: req
): Promise<AxiosResponse<any, any>> => request.post<res>(buildUrl(endpoint), data);
export const edit = <T>(endpoint: string, data?: T): Promise<AxiosResponse<any, any>> =>
	request.patch<T>(buildUrl(endpoint), data);
export const del = (endpoint: string): Promise<AxiosResponse<any, any>> =>
	request.delete(buildUrl(endpoint));
export const put = <T>(endpoint: string, data?: T): Promise<AxiosResponse<any, any>> =>
	request.put<T>(buildUrl(endpoint), data);
